import {Box, Flex, Grid, Image, Text, Title} from "@mantine/core";
import { IconPlus} from "@tabler/icons-react";
import ProductPlaceholderImage from '../../../../../assets/images/product_placeholder.png';
import {decode} from "html-entities";


const _Products = ({component}) => {
    return (

        <>
            <Box
                mx={component?.customize_styles?.general_decoration?.margin_x}
                my={component?.customize_styles?.general_decoration?.margin_y}
                px={component?.customize_styles?.general_decoration?.padding_x}
                py={component?.customize_styles?.general_decoration?.padding_y}
                bg={component?.customize_styles?.general_decoration?.background_color}
                style={{
                    boxShadow: `${component?.customize_styles?.general_decoration?.shadow_offset_x}px ${component?.customize_styles?.general_decoration?.shadow_offset_y}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px #00000014`,
                    borderRadius: `${component?.customize_styles?.general_decoration?.border_radius}px`,
                    border: `${component?.customize_styles?.general_decoration?.border_width}px solid ${component?.customize_styles?.general_decoration?.border_color}`,
                }}
            >
                <Title
                    c={component?.customize_styles?.text_decoration?.color}
                    mx={component?.customize_styles?.text_decoration?.margin_x}
                    my={component?.customize_styles?.text_decoration?.margin_y}
                    px={component?.customize_styles?.text_decoration?.padding_x}
                    py={component?.customize_styles?.text_decoration?.padding_y}
                    bg={component?.customize_styles?.text_decoration?.background_color}
                >
                    {component?.customize_properties?.label}
                </Title>
                <Grid gutter={0}>
                    {
                        component?.items?.map((item, index) => (
                            <Grid.Col span={6} key={index}>
                                <Box
                                    pos={"relative"}
                                    mx={component?.customize_styles?.box_decoration?.margin_x}
                                    my={component?.customize_styles?.box_decoration?.margin_y}
                                    px={component?.customize_styles?.box_decoration?.padding_x}
                                    py={component?.customize_styles?.box_decoration?.padding_y}
                                    bg={component?.customize_styles?.box_decoration?.background_color}
                                    style={{
                                        boxShadow: `${component?.customize_styles?.box_decoration?.shadow_offset_x}px -${component?.customize_styles?.box_decoration?.shadow_offset_y}px ${component?.customize_styles?.box_decoration?.shadow_blur_radius}px ${component?.customize_styles?.box_decoration?.shadow_blur_radius}px #00000014`,
                                        borderRadius: `${component?.customize_styles?.box_decoration?.border_radius}px`,
                                        border: `${component?.customize_styles?.box_decoration?.border_width}px solid ${component?.customize_styles?.box_decoration?.border_color}`,
                                    }}
                                >
                                    <Image
                                        fit="contain"
                                        src={item?.image_url}
                                        fallbackSrc={ProductPlaceholderImage}
                                        // bg={component?.customize_styles?.image_decoration?.color}
                                        style={{ borderRadius: `${component?.customize_styles?.image_decoration?.radius}px` }}
                                    />
                                    <Box mt={12}>
                                        <Title
                                            lineClamp={1}
                                            c={component?.customize_styles?.name_text_decoration?.color}
                                            fw={component?.customize_styles?.name_text_decoration?.font_weight}
                                            fz={component?.customize_styles?.name_text_decoration?.font_size}
                                            fs={component?.customize_styles?.name_text_decoration?.font_style}
                                        >
                                            {item?.name}
                                        </Title>
                                        <Text
                                            c={component?.customize_styles?.product_price_text_decoration?.color}
                                            bg={component?.customize_styles?.product_price_text_decoration?.background_color}
                                            fw={component?.customize_styles?.product_price_text_decoration?.font_weight}
                                            fz={component?.customize_styles?.product_price_text_decoration?.font_size}
                                        >
                                            {decode(item?.currency)} {item?.discount_price ? item.discount_price : item?.price}
                                        </Text>
                                        
                                        <Flex
                                            justify={"center"}
                                            align={"center"}
                                            pos={"absolute"}
                                            bottom={0}
                                            right={0}
                                            h={35}
                                            w={35}
                                            style={{
                                                background:
                                                    "linear-gradient(180deg, #277EFF 0%, #0C65E8 100%)",
                                                borderTopLeftRadius: "15px",
                                                borderBottomRightRadius: "15px",
                                            }}
                                        >
                                            <IconPlus color="#ffffff" size={22} />
                                        </Flex>
                                    </Box>
                                </Box>
                            </Grid.Col>
                        ))
                    }

                </Grid>
            </Box>
        </>

    )
}
export default _Products;